module.exports = __webpack_public_path__ + "static/media/icon-login-main.0f0bc780.png";